<template>
  <div>
    <app-title-bar>
      <app-material-icon name="inventory_2" />
      <h2>{{ $t("archives.views.Archives.header") }}</h2>
    </app-title-bar>
    <div class="d-flex flex-column row-gap-6 layout-spacing">
      <ArchivesSearchArea :additionalFields="metadata"
                          :loading="listSearchPending"
                          @submit="handleSubmit"
      />

      <ArchivesListBulkActions @download-selection="isArchivesDownloadDialogOpened = true"
                               @send-selection="isArchivesSendDialogOpened = true"
                               @share-selection="isArchivesShareDialogOpened = true"
      />

      <ArchivesList v-if="listSearchData"
                    class="my-5"
                    :loading="listSearchPending"
                    :items="listSearchData"
                    :itemCount="listSearchDataCount"
                    :page="page"
                    :sort="sort"
                    :additionalFields="metadata"
                    @page-change="onPageChange"
                    @sort-change="onSortChange"
      />
      <div v-else class="text-center mb-8">
        <AppLoader></AppLoader>
      </div>
    </div>

    <ArchivesDownloadDialog v-if="isArchivesDownloadDialogOpened"
                            @close="isArchivesDownloadDialogOpened = false"
    />

    <ArchivesShareDialog v-if="isArchivesShareDialogOpened"
                         @close="isArchivesShareDialogOpened = false"
    />

    <ArchivesSendDialog v-if="isArchivesSendDialogOpened"
                        @close="isArchivesSendDialogOpened = null"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash-es'

import ArchivesListBulkActions from '@/archives/ArchivesListBulkActions.vue'
import ArchivesDownloadDialog from '@/archives/dialogs/ArchivesDownloadDialog.vue'
import ArchivesSendDialog from '@/archives/dialogs/ArchivesSendDialog.vue'
import ArchivesShareDialog from '@/archives/dialogs/ArchivesShareDialog.vue'
import AppLoader from '@/common/AppLoader.vue'
import { useArchivesStore } from '@/stores/archivesStore'

import ArchivesList from '../ArchivesList.vue'
import ArchivesSearchArea from '../ArchivesSearchArea.vue'

const DEFAULT_LIST_SORT = [{ key: 'archiveDate', order: 'desc' }]

export default {
  name: 'Archives',
  components: {
    AppLoader,
    ArchivesDownloadDialog,
    ArchivesList,
    ArchivesListBulkActions,
    ArchivesSearchArea,
    ArchivesSendDialog,
    ArchivesShareDialog,
  },
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  data () {
    return {
      isArchivesDownloadDialogOpened: false,
      isArchivesSendDialogOpened: false,
      isArchivesShareDialogOpened: false,
      page: 1,
      search: {},
      sort: DEFAULT_LIST_SORT,
    }
  },
  head () {
    return {
      title: this.$t('archives.views.Archives.header') + ' - Closd',
    }
  },
  computed: {
    listSearchPending() {
      return this.archivesStore.listSearchPending
    },
    listSearchData() {
      return this.archivesStore.listSearchData
    },
    listSearchDataCount() {
      return this.archivesStore.listSearchDataCount
    },
    metadata() {
      return this.archivesStore.metadata
    },
    searchRequestSort () {
      const [sort] = this.sort

      return {
        sortBy: sort.key,
        sortDir: sort.order === 'asc' ? 'ASC' : 'DESC',
      }
    },
  },
  created () {
    this.handleSearchRequest = debounce(this.handleSearchRequest, 200, { leading: true })
  },
  methods: {
    handleSearchRequest (search = this.search, params = {}) {
      this.archivesStore.getSearchArchives(
        {
          search: {
            docName: search.docName,
            cmRef: search.folderRef,
            signerName: search.signerName,
            signedDocuments: search.signedDocuments,
            archiveDateStart: search.archiveDate?.begin,
            archiveDateEnd: search.archiveDate?.end,
            signingDateStart: search.signDate?.begin,
            signingDateEnd: search.signDate?.end,
            archiverName: search.archiverName,
            ...search.additionalFields,
          },
          params,
        },
      )
    },
    handleSubmit (search) {
      this.page = 1
      this.sortBy = undefined
      this.search = search
      this.handleSearchRequest()
    },
    onPageChange (newPage) {
      this.page = newPage
      this.handleSearchRequest(this.search, {
        page: this.page,
        ...this.searchRequestSort,
      })
    },
    onSortChange (sort) {
      if (sort[0].key !== this.searchRequestSort.sortBy || sort[0].order !== this.searchRequestSort.sortDir) {
        this.sort = sort

        this.handleSearchRequest(this.search, {
          page: this.page,
          ...this.searchRequestSort,
        })
      }
    },
  },
}
</script>
